/* Visor de fotos de la ficha: tocar una foto de la galería la abre a pantalla completa.
   Deslizar o flechas para pasar; tocar/clic en la foto amplía x2; Esc o X cierra. */
(function () {
  var gal = document.getElementById('gMain');
  if (!gal) return;
  var imgs = [].slice.call(gal.querySelectorAll('.g-item img'));
  if (!imgs.length) return;
  var ico = {
    x: '<svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    l: '<svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg>',
    r: '<svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>'
  };
  function grande(src) { return src.replace(/([?&])width=\d+/, '$1width=2000'); }
  var v = document.createElement('div');
  v.className = 'kv'; v.hidden = true;
  v.setAttribute('role', 'dialog'); v.setAttribute('aria-modal', 'true'); v.setAttribute('aria-label', 'Fotos del producto');
  v.innerHTML = '<div class="kv-pista">' + imgs.map(function (im) {
      return '<div class="kv-foto"><img src="" data-src="' + grande(im.currentSrc || im.src) + '" alt="' + (im.alt || '').replace(/"/g, '&quot;') + '"></div>';
    }).join('') + '</div>' +
    '<button type="button" class="kv-btn kv-cerrar" aria-label="Cerrar">' + ico.x + '</button>' +
    (imgs.length > 1 ? '<button type="button" class="kv-btn kv-ant" aria-label="Foto anterior">' + ico.l + '</button>' +
      '<button type="button" class="kv-btn kv-sig" aria-label="Foto siguiente">' + ico.r + '</button>' +
      '<p class="kv-cuenta"><span>1</span> / ' + imgs.length + '</p>' : '');
  document.body.appendChild(v);
  var pista = v.querySelector('.kv-pista'), fotos = [].slice.call(v.querySelectorAll('.kv-foto')), num = v.querySelector('.kv-cuenta span'), ultimoFoco = null;

  function cargar(i) { [i - 1, i, i + 1].forEach(function (k) { var f = fotos[k]; if (f) { var im = f.querySelector('img'); if (!im.getAttribute('src')) im.src = im.getAttribute('data-src'); } }); }
  function actual() { return Math.round(pista.scrollLeft / pista.clientWidth) || 0; }
  function ir(i, suave) {
    i = Math.max(0, Math.min(fotos.length - 1, i)); cargar(i);
    fotos.forEach(function (f) { f.classList.remove('zoom'); });
    pista.scrollTo({ left: i * pista.clientWidth, behavior: suave ? 'smooth' : 'auto' });
    if (num) num.textContent = i + 1;
  }
  function abrir(i) {
    ultimoFoco = document.activeElement;
    v.hidden = false; document.documentElement.classList.add('kv-abierto');
    ir(i, false); void v.offsetWidth; v.classList.add('on'); v.querySelector('.kv-cerrar').focus();
  }
  function cerrar() {
    v.classList.remove('on'); document.documentElement.classList.remove('kv-abierto');
    setTimeout(function () { v.hidden = true; }, 250);
    if (ultimoFoco && ultimoFoco.focus) ultimoFoco.focus();
  }
  imgs.forEach(function (im, i) { im.addEventListener('click', function () { abrir(i); }); });
  v.querySelector('.kv-cerrar').addEventListener('click', cerrar);
  var a = v.querySelector('.kv-ant'), s = v.querySelector('.kv-sig');
  if (a) a.addEventListener('click', function () { ir(actual() - 1, true); });
  if (s) s.addEventListener('click', function () { ir(actual() + 1, true); });
  var t; pista.addEventListener('scroll', function () { clearTimeout(t); t = setTimeout(function () { var i = actual(); cargar(i); if (num) num.textContent = i + 1; }, 80); });
  fotos.forEach(function (f) {
    f.querySelector('img').addEventListener('click', function (e) {
      var z = f.classList.toggle('zoom');
      if (z) { var r = f.getBoundingClientRect(); f.scrollLeft = (e.clientX - r.left) / r.width * (f.scrollWidth - f.clientWidth); f.scrollTop = (e.clientY - r.top) / r.height * (f.scrollHeight - f.clientHeight); }
    });
  });
  document.addEventListener('keydown', function (e) {
    if (v.hidden) return;
    if (e.key === 'Escape') cerrar();
    else if (e.key === 'ArrowRight') ir(actual() + 1, true);
    else if (e.key === 'ArrowLeft') ir(actual() - 1, true);
  });
  window.addEventListener('resize', function () { if (!v.hidden) ir(actual(), false); });
})();
